import React from 'react';
import { SVGAttributes } from 'react';

export const PDFIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2ZM3.2 6.4H5.1875C5.725 6.4 6.1375 6.44219 6.425 6.52656C6.71563 6.61094 6.93281 6.73281 7.07656 6.89219C7.22344 7.05156 7.32188 7.24531 7.37188 7.47344C7.425 7.69844 7.45156 8.04844 7.45156 8.52344V9.18437C7.45156 9.66875 7.40156 10.0219 7.30156 10.2438C7.20156 10.4656 7.01719 10.6359 6.74844 10.7547C6.48281 10.8734 6.13438 10.9328 5.70312 10.9328H5.17344V13.9891H3.2V6.4ZM5.17344 7.69844V9.62969C5.22969 9.63281 5.27813 9.63438 5.31875 9.63438C5.5 9.63438 5.625 9.59062 5.69375 9.50313C5.76562 9.4125 5.80156 9.22656 5.80156 8.94531V8.32188C5.80156 8.0625 5.76094 7.89375 5.67969 7.81563C5.59844 7.7375 5.42969 7.69844 5.17344 7.69844ZM8.01875 6.4H9.49531C10.4484 6.4 11.0922 6.44375 11.4266 6.53125C11.7641 6.61875 12.0203 6.7625 12.1953 6.9625C12.3703 7.1625 12.4797 7.38594 12.5234 7.63281C12.5672 7.87656 12.5891 8.35781 12.5891 9.07656V11.7344C12.5891 12.4156 12.5563 12.8719 12.4906 13.1031C12.4281 13.3313 12.3172 13.5109 12.1578 13.6422C11.9984 13.7703 11.8016 13.8609 11.5672 13.9141C11.3328 13.9641 10.9797 13.9891 10.5078 13.9891H8.01875V6.4ZM9.99219 7.69844V12.6906C10.2766 12.6906 10.4516 12.6344 10.5172 12.5219C10.5828 12.4062 10.6156 12.0953 10.6156 11.5891V8.64062C10.6156 8.29688 10.6047 8.07656 10.5828 7.97969C10.5609 7.88281 10.5109 7.8125 10.4328 7.76875C10.3547 7.72188 10.2078 7.69844 9.99219 7.69844ZM16.6672 6.4H13.325V13.9891H15.2984V10.8016H16.5172V9.35781H15.2984V7.91875H16.6672V6.4Z"
        fill="#D70000"
      />
    </svg>
  );
};

export default PDFIcon;
